// axios 封装
import axios from 'axios'
import Vue from 'vue'
import router from '../router'
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { Toast } from "vant";
import { removeToken, removeData } from "@/utils/auth";
import store from '../store'
const server = axios.create({
  // 请求基地址
  baseURL: process.env.VUE_APP_URL,
  timeout: 20000 // 控制时间 2000 = 2s，
})

// 请求拦截器
server.interceptors.request.use(async (config) => {
  // 请求头配置 config
  let token
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    token = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // config.url=config.url.replace("api/", "")
  // console.log(config.url);
  try {
    const fp = await FingerprintJS.load();
    let result = await fp.get();
    config.headers.appDeviceld = result.visitorId
  } catch (error) {
    console.error('获取访问者标识符失败', error);
  }
  config.headers.Authorization = token
  config.headers.appSource = 3;
  config.headers.channelCode = store.state.perpetual.channelCode;
  return config
})
// 响应拦截白名单
const noResponse = ['/', '/mine', '/commissionSharing']
const noError = ['/api/app/vip/v2/package/versionList']
// 响应拦截器
server.interceptors.response.use((res) => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  let status = noResponse.indexOf(window.location.pathname) == -1
  let whiteError = noError.indexOf(res.config.url) == -1
  if (code == 401) {
    removeToken()
    removeData()
    store.commit('user/SET_TOKEN', null)
    store.commit('user/SET_DATA', null)
    if (status) {
      router.push("/login");
    }
    return res.data
  } else if (code != 200 && whiteError) {
    Toast(msg)
    return Promise.reject('error')
  } else {
    return res.data
  }
}, error => {
  let { message } = error;
  if (message == "Network Error") {
    message = "接口连接异常";
  } else if (message.includes("timeout")) {
    message = "系统接口请求超时";
  } else if (message.includes("Request failed with status code")) {
    message = "系统接口" + message.substr(message.length - 3) + "异常";
  }
  Toast(message)
  return Promise.reject(error)
})

// vue 全局加上 $http
// 在组件中使用 this.$http 就相当于 server 了
Vue.prototype.$http = server
export default server